import { NgModule } from "@angular/core"
import { CategorySelectionComponent } from "@component/category-selection/category-selection.component"
import { SearchbarComponent } from "@component/shared/searchbar/searchbar.component"
import { SafeHTML, SafeURL } from "@pipe/safe"
import { MatAutocompleteModule } from "@angular/material/autocomplete"
import { SharedModule } from "./shared.module"
import { ImageSliderComponentModule } from "@component/generic/image-slider/image-slider.component"
import { LikeButtonComponentModule } from "@component/interaction-buttons/like-button/like-button.component"
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons'
import { AuthorComponentModule } from "@component/author/author.component"
import { EditorModule } from "@tinymce/tinymce-angular"
import { ImageUploadBoxComponentModule } from "@component/generic/image-upload-box/image-upload-box.component"
import { EditImagesComponentModule } from "@component/generic/edit-images/edit-images.component"
import { MatStepperModule } from "@angular/material/stepper"
import { ViewsDisplayModule } from "@component/interaction-buttons/views-display/views-display.component"
import { MatExpansionModule } from "@angular/material/expansion"
import { CreditsWarningComponent } from "@component/credits-warning/credits-warning.component"
import { ImageFormcontrolComponent } from "@customformcontrols/image-formcontrol/image-formcontrol.component"
import { StateService } from "@service/state.service"

/*
  This module is imported in the 4 big entity modules blog, job, wiki, advert
*/
@NgModule({
  declarations: [
    CategorySelectionComponent,
    SearchbarComponent,
    SafeHTML,
    SafeURL,
    CreditsWarningComponent,
    ImageFormcontrolComponent,
  ],
  imports: [
    SharedModule,
    ImageSliderComponentModule,
    LikeButtonComponentModule,
    ShareButtonsModule,
    AuthorComponentModule,
    EditorModule,
    ImageUploadBoxComponentModule,
    EditImagesComponentModule,
    ViewsDisplayModule,

    MatStepperModule,
    MatAutocompleteModule,
    MatExpansionModule,
  ],
  exports: [
    CategorySelectionComponent,
    SearchbarComponent,
    SafeHTML,
    SafeURL,
    CreditsWarningComponent,
    ImageFormcontrolComponent,

    SharedModule,
    ImageSliderComponentModule,
    LikeButtonComponentModule,
    ShareButtonsModule,
    AuthorComponentModule,
    EditorModule,
    ImageUploadBoxComponentModule,
    EditImagesComponentModule,
    ViewsDisplayModule,

    MatStepperModule,
    MatAutocompleteModule,
    MatExpansionModule,
  ],
  providers: [
    StateService
  ]
})
export class EntityModule { }